let Modals = {
    init: () => {
        Modals.initDynamicLoadingModal();
        Modals.initOnSaveDismiss();
        Modals.initVideoModal();
    },

    initDynamicLoadingModal: () => {
        let modals = $('.modal');

        modals.each(function() {
            let $this = $(this);

            if (!$this.is('#modal-video')) {
                $this.on('show.bs.modal', (e) => {
                    const url = e.relatedTarget?.dataset?.url;

                    if (url) {
                        $this.empty();
                        Modals.setModalLoading($this);

                        const loadTimeout = setTimeout(() => {
                            $this.empty();
                        }, 500);

                        $this.load(url, () => {
                            clearTimeout(loadTimeout);
                            try {
                                Plugins.init();
                                Form.init();
                                VideoPlayer.init();
                            } catch (error) {
                                console.error("Error initializing modal plugins:", error);
                            }
                        });
                    }
                });

                $this.on('hidden.bs.modal', () => {
                    $this.empty();
                    Modals.setModalLoading($this);
                });
            }
        });
    },

    setModalLoading: (modal) => {
        let modalDialog = document.createElement("div"),
            modalContent = document.createElement("div"),
            modalBody = document.createElement("div"),
            img = document.createElement("img");

        modalDialog.className = "modal-dialog modal-dialog-centered modal-lg";
        modalContent.className = "modal-content";
        modalBody.className = "modal-body modal-body-center align-items-center";
        img.className = "loading my-5";
        img.src = `${Session.rootUrl}${Session.domain}/images/spinner.svg`;
        img.width = 50;
        img.height = 50;

        modalBody.appendChild(img);
        modalContent.appendChild(modalBody);
        modalDialog.appendChild(modalContent);

        modal.html(modalDialog);
    },

    initOnSaveDismiss: () => {
        let $modals = $('.modal[data-save-dismiss]');
        $modals.each(function() {
            let $this = $(this),
                modalId = this.id;

            $this.on('show.bs.modal', function(e) {
                if (sessionStorage.getItem(modalId)) e.preventDefault();
            });

            if (sessionStorage.getItem(modalId)) return;

            $this.on('hide.bs.modal', function() {
                sessionStorage.setItem(modalId, 'dismissed');
            });
        });
    },

    initVideoModal: () => {
        let $videoSrc;

        $('.video-btn').click(function() {
            $videoSrc = $(this).data("src");
        });

        $('#modal-video').on('shown.bs.modal', function() {
            $("#video").attr('src', $videoSrc + "?autoplay=1&amp;modestbranding=1&amp;showinfo=0");
        })

        $('#modal-video').on('hide.bs.modal', function() {
            $("#video").attr('src', $videoSrc);
        })
    }
};

export default Modals;


